import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

let cachedPublicIp = null;

export const fetchPublicIp = async () => {
  if (cachedPublicIp) return cachedPublicIp;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    const res = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
    clearTimeout(timeoutId);
    if (res.ok) {
      const data = await res.json();
      if (data && data.ip) {
        cachedPublicIp = data.ip;
        return data.ip;
      }
    }
  } catch (e) {
    // Fallback to backend IP detection if ipify is blocked or offline
  }
  return null;
};

export const startVideoWatchTrack = async (data) => {
  const publicIp = await fetchPublicIp();
  const payload = {
    ...data,
    public_ip: publicIp
  };

  const response = await fetch(`${API_BASE_URL}/video-watch-track/start`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const pingVideoWatchTrack = async (trackId, watchedSeconds = 0) => {
  if (!trackId) return;
  try {
    await fetch(`${API_BASE_URL}/video-watch-track/ping/${trackId}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ video_duration: watchedSeconds, watched_seconds: watchedSeconds })
    });
  } catch (e) {
    // Silent fail for ping heartbeats
  }
};

export const fetchCourseWatchAnalytics = async (courseId, startDate, endDate) => {
  let url = `${API_BASE_URL}/video-watch-track/course/${courseId}`;
  const queryParams = [];
  if (startDate) queryParams.push(`startDate=${startDate}`);
  if (endDate) queryParams.push(`endDate=${endDate}`);
  if (queryParams.length > 0) url += `?${queryParams.join('&')}`;

  const response = await fetch(url, { headers: getHeaders() });
  return handleResponse(response);
};

export const downloadCourseWatchAnalyticsCsv = async (courseId, startDate, endDate) => {
  let url = `${API_BASE_URL}/video-watch-track/course/${courseId}?exportCsv=true`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;

  const response = await fetch(url, { headers: getHeaders() });
  if (!response.ok) {
    throw new Error('Failed to download CSV export');
  }
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = `course_${courseId}_watch_analytics.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export const fetchUserWatchAnalytics = async () => {
  const response = await fetch(`${API_BASE_URL}/video-watch-track/user`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchUserWatchAnalyticsById = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/video-watch-track/user/${userId}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

